@file:kotlin.js.JsExport
/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2024] Narbase Technologies
 * All Rights Reserved.
 * Created by shalaga44
 * On: 19/Aug/2024.
 */

package com.narbase.letsgo.web.routing.domain.appSettings

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.dto.EnumDtoName
import com.narbase.letsgo.dto.core.EnumPersistenceName
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport

@OptIn(ExperimentalJsExport::class)
@JsExport
@Suppress("NON_EXPORTABLE_TYPE")
data class CapacitorAppInfoDto(
    val name: String,
    val id: String,
    val build: String,
    val version: String,
    @Suppress("NON_EXPORTABLE_TYPE") val platform: DtoName<Platform>,
    val webBuildVersion: String?
)

enum class Platform(val code: String) : EnumDtoName, EnumPersistenceName {
    @Suppress("EnumEntryName")
    iOS("ios"),
    Android("android"),
    Web("web"),
    ;

    override val dtoName: String
        get() = code
    override val persistenceName: String
        get() = dtoName

    companion object {
        fun from(dtoName: String): Platform {
            return Platform.values().firstOrNull { it.code == dtoName }
                ?: throw NotImplementedError("Unknown platform: $dtoName")

        }
    }
}

enum class WebPlatform(val code: String) : EnumDtoName, EnumPersistenceName {
    @Suppress("EnumEntryName")
    iOS("web_ios"),
    Android("web_android"),
    Desktop("web_desktop"),
    ;

    override val dtoName: String
        get() = code
    override val persistenceName: String
        get() = dtoName

    companion object {
        fun from(dtoName: String): Platform {
            return Platform.values().firstOrNull { it.code == dtoName }
                ?: throw NotImplementedError("Unknown platform: $dtoName")

        }

        fun isIOS(userAgent: String): Boolean {
            return userAgent.contains("iPhone", ignoreCase = true) ||
                    userAgent.contains("iPad", ignoreCase = true) ||
                    userAgent.contains("iPod", ignoreCase = true)
        }

        fun isAndroid(userAgent: String): Boolean {
            return userAgent.contains("Android", ignoreCase = true)
        }

        fun isDesktop(userAgent: String): Boolean {
            return !isIOS(userAgent) && !isAndroid(userAgent)
        }
    }

}
